// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__Nm2d5","sendOtp":"AuthorizeToLogin_sendOtp__3-Pqt"};